import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import useRadioGroup from './hooks/useRadioGroup'
import RadioGroup from '../control/RadioGroup'

type RadioGroupPlaygroundType = ReturnType<typeof useRadioGroup>

const RadioGroupPlaygroundView = (props: RadioGroupPlaygroundType) => {
    const { dataList, value_1, value_2, value_3, onChange_1, onChange_2, onChange_3 } = props
    const classes = useStyles()

    return (
        <div>
            <Typography variant="h3" gutterBottom>
                Control: Radio Group
            </Typography>
            <RadioGroup
                name={'rdo_1'}
                label={'Control'}
                dataSource={dataList}
                selectedValue={value_1}
                onChange={onChange_1}
                overrideClass={{ root: classes.radio }}
            />
            <br />
            <RadioGroup
                name={'rdo_2'}
                label={'Control (required)'}
                dataSource={dataList}
                selectedValue={value_2}
                onChange={onChange_2}
                labelPlacement={'bottom'}
                overrideClass={{ root: classes.radio }}
                required
            />
            <br />
            <RadioGroup
                name={'rdo_3'}
                label={'Control (disabled)'}
                dataSource={dataList}
                selectedValue={value_3}
                onChange={onChange_3}
                alignment={'vertical'}
                disabled
            />
        </div>
    )
}

//Controller
const RadioGroupPlayground = () => {
    const radioGroupModel = useRadioGroup()
    return <RadioGroupPlaygroundView {...radioGroupModel} />
}

export default RadioGroupPlayground

const useStyles = makeStyles((theme: Theme) => ({
    radio: {
        color: `${theme.palette.primary.main} !important`,
    },
}))
